import axios from 'axios';
import Cookies from 'js-cookie';
const API_BASE_URL = 'https://staff.praxisamring-hameln.de';

// Get auth token from cookies
const getAuthToken = () => {
  return (
     localStorage.getItem('authToken') ||
        Cookies.get('jwtToken') ||
        null
  );
};

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Authorization': `Bearer ${getAuthToken()}`,
    'Content-Type': 'application/json',
  },
});

// Services service methods
export const servicesService = {
  // Get all services
  getAllServices: async () => {
    try {
      const response = await apiClient.get('/services/services');
      return response.data;
    } catch (error) {
      console.error('Error fetching services:', error);
      throw error;
    }
  },

  // Get single service by ID
  getServiceById: async (id) => {
    try {
      const response = await apiClient.get(`/services/service/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching service:', error);
      throw error;
    }
  },

  // Create new service
  createService: async (serviceData) => {
    try {
      const response = await apiClient.post('/services/add-service', serviceData);
      return response.data;
    } catch (error) {
      console.error('Error creating service:', error);
      throw error;
    }
  },

  // Update service
  updateService: async (id, serviceData) => {
    try {
      const response = await apiClient.put(`/services/update-service/${id}`, serviceData);
      return response.data;
    } catch (error) {
      console.error('Error updating service:', error);
      throw error;
    }
  },

  // Delete service
  deleteService: async (id) => {
    try {
      const response = await apiClient.delete(`/services/delete-service/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting service:', error);
      throw error;
    }
  },

  deleteAllServices: async () => {
    try {
      const response = await apiClient.delete('/services/delete-all-services');
      return response.data;
    } catch (error) {
      console.error('Error deleting all services:', error);
      throw error;
    }
  },
}; 